import { render, staticRenderFns } from "./MealsTypeEdit.vue?vue&type=template&id=24d2a630&scoped=true&"
import script from "./MealsTypeEdit.vue?vue&type=script&lang=js&"
export * from "./MealsTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2a630",
  null
  
)

export default component.exports